export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || "https://staging-api.wurabet.com"

export const API_URL = `${SERVER_URL}/api`
export const imagePath = (folderName, file) =>
  `${SERVER_URL}/images/${folderName}/${file}`

export const currency = "NGN"
export const sitename = "BETYAKATA"
